import { Coordenadas } from "./Vistas/PanelCoordenadas/Coordenadas";
import { Login } from "./Vistas/Login";
import { Rutas } from "./Vistas/PanelRutas/Rutas";
import { GaleriaDeCercas } from "./Vistas/GaleriaDeCercas";
import { Dispositivos } from "./Vistas/PanelDispositivos/Dispositivos";
import { ConfiguracionDispositivos } from "./Vistas/PanelDispositivos/ConfiguracionDispositivos";
import { InicioAdmin } from "./Vistas/PanelAdministrador/InicioAdmin";
import { DispositivoAsoc } from "./Vistas/PanelAdministrador/DispositivosAdmin/DispositivoAsoc";
import { Empresas } from "./Vistas/PanelAdministrador/EmpresasAdmin/Empresas";
import { RutasAdmin } from "./Vistas/PanelAdministrador/RutasAdmin/RutasAdmin";
import { SonidosGeocerca } from "./Vistas/PanelAdministrador/GeocercasAdmin/Geocercas";
import { ProtocolosDispositivo } from "./Vistas/PanelAdministrador/Protocolos/Protocolos";
import { PausasActivas } from "./Vistas/PanelAdministrador/PausasActivas/PausasActivasNuevo";
import { CinturonesSeguridad } from "./Vistas/CinturonesSeguridad";
import { CinturonesSeguridadAlertas } from "./Vistas/CinturonesSeguridadAlertas";
import { SvgTest } from "./Vistas/SvgTest";
import { Vehiculos } from "./Vistas/PanelAdministrador/VehiculosAdmin/Vehiculos";
import { CinturonesAdmin } from "./Vistas/PanelAdministrador/CinturonesAdmin/CinturonesAdmin";
import { PosicionesAdmin } from "./Vistas/PanelAdministrador/CinturonesAdmin/PosicionesAdmin";
import { MODULES } from "./Utils/modulos";


export const routes = [
    { path: '/', component: <Login /> },
    { path: '/rutas', component: <Rutas />, module: MODULES.GEOCERCAS },
    { path: '/coordenadas/:ruta', component: <Coordenadas />, module: MODULES.GEOCERCAS },
    { path: '/galeria', component: <GaleriaDeCercas />, module: MODULES.GEOCERCAS },
    { path: '/cinturones-seguridad', component: <CinturonesSeguridad />, module: MODULES.CINTURONES },
    { path: '/cinturones-seguridad/alertas', component: <CinturonesSeguridadAlertas />, module: MODULES.CINTURONES },
    { path: '/svg-test', component: <SvgTest /> },
    { path: '/dispositivos', component: <Dispositivos />, module: MODULES.GEOCERCAS },
    { path: '/configuracion-dispositivos', component: <ConfiguracionDispositivos />, module: MODULES.GEOCERCAS },

    //Administracion
    { path: '/panel-administrador', component: <InicioAdmin />, adminOnly: true },
    { path: '/vehiculos-admin', component: <Vehiculos />, adminOnly: true },
    { path: '/cinturones-admin', component: <CinturonesAdmin />, adminOnly: true },
    { path: '/posiciones-admin', component: <PosicionesAdmin />, adminOnly: true },
    { path: '/dispositivo-asoc', component: <DispositivoAsoc />, adminOnly: true },
    { path: '/empresas-admin', component: <Empresas />, adminOnly: true },
    { path: '/rutas-admin', component: <RutasAdmin />, adminOnly: true },
    { path: '/geo-admin', component: <SonidosGeocerca />, adminOnly: true },
    { path: '/protocolos-dispositivo', component: <ProtocolosDispositivo />, adminOnly: true },
    { path: '/pausas-activas', component: <PausasActivas />, module: MODULES.PAUSAS }

] 
